import { Injectable } from "@angular/core";
import { Platform, ToastController, AlertController, LoadingController, NavController } from "@ionic/angular";
import { Observable, from ,tap,map} from 'rxjs';
import { NGXLogger } from "ngx-logger";
import { Device } from '@capacitor/device';
import { Browser } from '@capacitor/browser';


@Injectable({ providedIn: 'root' })
export class PageHelper {

  loadingQueue = [];

  constructor(
    public alertController: AlertController,
    public loadingCtrl: LoadingController,
    private platform: Platform,
    private nav: NavController,
    private toastController: ToastController,
    private log: NGXLogger,
  ) {

  }

  /**  取回uuid */
   getUUid(): Observable<string> {
   // const info = await Device.getId();
    return from(Device.getId()).pipe(
      map(v=>v.identifier),
      tap(uuid=>{
        this.log.trace("最終uuid:" + uuid);
      })      
    )

    // //this.log.debug("試取得裝置資訊", JSON.stringify(info));
    // const obs1 = new Observable<string>((observer) => {
    //   //ios的uuid要另外處理，因為有可能會變換
     
    //     var uuid = info.identifier;
       
       
    //     observer.next(uuid);
    //     observer.complete();
     
    // });

    // return obs1.toPromise();
  }



  // /**顯示確認視窗 */
  // Confirm(msg: string): Promise<boolean> {

  //   return new Promise((resolve, reject) => {
  //     // alertController.create(...) returns a promise!
  //     this.alertController
  //       .create({
  //         header: '請確認 !',
  //         message: msg,
  //         buttons: [
  //           {
  //             text: '取消',
  //             role: 'cancel',
  //             cssClass: 'secondary',
  //             handler: () => resolve(false)
  //           },
  //           {
  //             text: '確定',
  //             handler: () => resolve(true)
  //           }
  //         ]
  //       })
  //       .then(alert => {
  //         alert.present();
  //       });
  //   });
  // }


  // /**顯示確認視窗 */
  // Alert(msg: string, title?: string): Promise<boolean> {

  //   return new Promise((resolve, reject) => {
  //     // alertController.create(...) returns a promise!
  //     let titleDefault = "訊息!"
  //     if (title) {
  //       titleDefault = title;
  //     }
  //     this.alertController
  //       .create({
  //         header: titleDefault,
  //         message: msg,
  //         buttons: [
  //           {
  //             text: '確定',
  //             handler: () => resolve(true)
  //           }
  //         ]
  //       })
  //       .then(alert => {
  //         alert.present();
  //       });
  //   });
  // }


  /**顯示訊息 */
  async toast(msg: string, durationTime?: number, position?: 'top' | 'bottom' | 'middle') {
    //預設二秒
    var time = 2000;
    var positionDefault: 'top' | 'bottom' | 'middle' = "middle";

    if (durationTime) {
      time = durationTime;
    }

    if (position) {
      positionDefault = position;
    }

    // let toast1 = await this.toastController.create({
    //   message: msg,
    //   duration: time,
    //   position: positionDefault

    // });

    // toast1.present();

    //Toast.show(msg, time + "", 'bottom')
    // Toast toast = new Toast({
    //     message: msg,
    //     duration: time,
    // });
    // this.nav.present(toast);
  }

  // show(msg?: string) {
  //   let mes = "載入中";
  //   if (msg != null && msg != "") {
  //     mes = msg;
  //   }
  //   this.spinnerDialog.show("訊息", mes, false);

  // }

  // hide() {
  //   this.spinnerDialog.hide();
  // }

  async openWin(url: string, locationShow?: boolean) {
    await Browser.open({ url: url });
  }

  setBackground(path) {
    const ionContent = document.querySelectorAll('ion-content');
    Object.keys(ionContent).map((key) => {
      if (path != null && path != '') {
        if (ionContent[key].getAttribute("style").includes("--background")) {
          let style = ionContent[key].getAttribute("style");
          let startIndex = style.indexOf("--background");
          let endIndex = style.indexOf(";", startIndex);
          style = style.substring(0, startIndex) + style.substring(endIndex + 1);
          ionContent[key].setAttribute("style", style + " --background:url(/assets/imgs/" + path + ") no-repeat center center / cover;");
        }
        else {
          ionContent[key].setAttribute("style", ionContent[key].getAttribute("style") + " --background:url(/assets/imgs/" + path + ") no-repeat center center / cover;");
        }
      }
      else {
        path = "background.jpg";
        ionContent[key].setAttribute("style", ionContent[key].getAttribute("style") + " --background:url(/assets/imgs/" + path + ") no-repeat center center / cover;");
      }
    });
  }
}
